"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartAddedDiscountCode = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartAddedDiscountCode(discountCode, discountValue) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: 'add_discount',
        eventLabel: discountCode,
        eventData: {
            feature_category: enums_1.GA4FeatureCategory.Cart,
            eventName: enums_1.GA4EventName.AddDiscount,
            discount_code: discountCode,
            discount_value: discountValue,
        },
    });
}
exports.trackCartAddedDiscountCode = trackCartAddedDiscountCode;
//# sourceMappingURL=trackCartAddedDiscountCode.js.map